/** Compact SVG flags for language switcher (Austria = DE, Saudi = AR). */

export function FlagAustria({ className = '' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 21 15" width="22" height="16" aria-hidden focusable="false">
      <rect width="21" height="15" rx="2" fill="#ed2939" />
      <rect y="5" width="21" height="5" fill="#fff" />
    </svg>
  )
}

export function FlagSaudi({ className = '' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 21 15" width="22" height="16" aria-hidden focusable="false">
      <rect width="21" height="15" rx="2" fill="#006c35" />
      <path
        fill="#fff"
        d="M3.2 5.1h14.6v1.05H3.2zm1.1 1.85h12.4c.2 0 .35.12.35.3v.95c0 .7-.55 1.25-1.25 1.25H5.2c-.7 0-1.25-.55-1.25-1.25v-.95c0-.18.15-.3.35-.3z"
        opacity="0.95"
      />
      <path
        fill="#fff"
        d="M6.2 10.4h8.6c.35 0 .55.35.35.65l-.55.85H7.4l-.55-.85c-.2-.3 0-.65.35-.65z"
      />
    </svg>
  )
}
